export const GET_HEADER_DATA = "GET_HEADER_DATA";
export const CHECK_MODAL = "CHECK_MODAL";
